export default "__VITE_ASSET__DjzPBJtF__"